module.exports = __webpack_public_path__ + "static/media/jabba-desilijic-tiure.8c233aa5.jpg";